import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
function loadMetaPixel() {
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  w.fbq('init', '2299121003934701');
  w.fbq('track', 'PageView');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=2299121003934701&ev=PageView&noscript=1';
  document.body.appendChild(img);
}
function loadUtmifyPixel() {
  const w = window as any;
  if (w.__utmifyLoaded) return;
  w.__utmifyLoaded = true;
  w.pixelId = '6a4b09ae72a1f48384775c56';
  const a = document.createElement('script');
  a.setAttribute('async', '');
  a.setAttribute('defer', '');
  a.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
  document.head.appendChild(a);
}
function addPreconnect(href: string, crossOrigin?: boolean) {
  if (document.querySelector(`link[rel="preconnect"][href="${href}"]`)) return;
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  if (crossOrigin) link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
}
export function App() {
  useEffect(() => {
    // Preconnect to image CDN early — speeds up LCP by ~100-300ms on cold loads
    addPreconnect('https://cdn.magicpatterns.com', true);
    // Defer analytics pixels — load when browser is idle to reduce main thread work
    const loadPixels = () => {
      loadMetaPixel();
      loadUtmifyPixel();
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixels, {
        timeout: 3500
      });
    } else {
      setTimeout(loadPixels, 2000);
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}